import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { AuthService } from '../../features/auth/auth.service';
import { LogLogoutAction, LogoutAction, ClearLoginStateAction } from '../../features/auth/auth.actions';


@Injectable()
export class LogoutService {

  public constructor(
    private readonly store: Store<AppState>,
    private readonly authService: AuthService
  ) { }

  public _continue(): void {
    this.deleteCookie('auth_token');
    this.deleteCookie('vds');
    this.deleteCookies();
    // sessionStorage.removeItem('auth_token');
    // sessionStorage.removeItem('refresh_token');
    // this.store.dispatch(new LogLogoutAction());
    this.store.dispatch(new ClearLoginStateAction());
    this.authService.logout();
  }

  private setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + '=' + value + ';path=/;secure;expires=' + d.toUTCString();
  }

  private deleteCookie(name) {
    this.setCookie(name, '', -1);
  }

  private deleteCookies() {
    const allCookies = document.cookie.split(';');
    for (let i = 0; i < allCookies.length; i++) {
      this.deleteCookie(allCookies[i]);
    }
  }

}
